import type { SetupProgress } from "../registry/types";

/**
 * Pure derivation of whether the intake modal should be visible for the
 * active product, given its persisted progress row.
 *
 * Rules:
 *   - No row → no modal (legacy / fresh merchants).
 *   - Team-dismissed (`dismissedAt` set) → no modal, never returns until
 *     a fresh row is created.
 *   - Intake already submitted → no modal (the merchant has moved on).
 *   - Currently deferred (`deferredUntil` in the future) → no modal until
 *     the timestamp passes.
 *
 * `now` is injected so tests can deterministically control the deferral
 * comparison without mocking globals at every site. Production callers
 * pass `Date.now()`.
 */
export function deriveShowIntake(
  progress: SetupProgress | null,
  now: number,
): boolean {
  if (progress == null) {
    return false;
  }
  if (progress.dismissedAt != null) {
    return false;
  }
  if (progress.intakeCompletedAt != null) {
    return false;
  }
  if (
    progress.deferredUntil != null &&
    progress.deferredUntil.getTime() > now
  ) {
    return false;
  }
  return true;
}
